import { cheat } from 'automaton/actions/RequestSpinAction'
import GraphicsButton  from 'core/display/buttons/GraphicsButton'
import ImageButton from 'core/display/buttons/ImageButton'
import makeContainer from 'core/display/simple/Container'
import makeGraphics from 'core/display/simple/Graphics'
import { enableFade } from 'core/handlers/FadeHandler'
import { signal } from 'services/SignalsService'

let spinModel

let scale
//
const images = []

let currentSym

export function makeCheatEntity() {
  const symH = game.models.ItemsModel.height
  const symW = game.models.ItemsModel.width
  const self = new makeContainer
  const fade = enableFade(self)
  spinModel = game.models.SpinModel.get()

  spinModel.reelSymbols.forEach((symbol) => images.push(`images/items/static/${symbol}.png`))

  scale = 1000 / (spinModel.matrix.length * symW) < 1 ? 1000 / (spinModel.matrix.length * symW) : 1

  let symbolsMatrix = spinModel.matrix

  //background
  const back = makeGraphics(background)
  self.addChild(back)
  //background-end

  //symbols
  const symbolsContainer = new makeContainer
  makeSymbols(symbolsMatrix, symbolsContainer, symH, symW)
  self.addChild(symbolsContainer)
  //symbols-end

  //range
  let rangeLandX = (1920 - symW) / 2
  let rangeLandY = (1080 - Math.ceil(spinModel.reelSymbols.length / 2) * symH / 2) / 2
  let rangePortX = (1080 - symW) / 2
  let rangePortY = (1920 - Math.ceil(spinModel.reelSymbols.length / 2) * symH / 2) / 2

  const range = new makeContainer
  range.visible = false

  const rangeBack = new makeGraphics(makeRangeBackground(Math.ceil(spinModel.reelSymbols.length / 2), rangeLandX, rangeLandY, rangePortX, rangePortY, symH, symW))
  range.addChild(rangeBack)

  spinModel.reelSymbols.forEach((symbol, index) => {
    if (index == Math.ceil(spinModel.reelSymbols.length / 2)) {
      rangeLandX += symW * 0.5
      rangeLandY = (1080 - Math.ceil(spinModel.reelSymbols.length / 2) * symH / 2) / 2
      rangePortX += symW * 0.5
      rangePortY = (1920 - Math.ceil(spinModel.reelSymbols.length / 2) * symH / 2) / 2
    }
    const name = `makecheat-${symbol}`
    const rangeImg = new ImageButton(makeImageObj(symbol, 0.5, name, rangeLandX, rangeLandY, rangePortX, rangePortY))
    range.addChild(rangeImg)
    rangeLandY += symH * 0.5
    rangePortY += symH * 0.5
  })
  self.addChild(range)
  //range-end

  //gocheat-button
  const lx = (1920 - symW * scale * spinModel.matrix.length) / 2 + symW * scale * spinModel.matrix.length
  const ly = (1080 - symH * scale * spinModel.matrix[0].length) / 2 + symH * scale * spinModel.matrix[0].length
  const px = (1080 - symW * scale * spinModel.matrix.length) / 2 + symW * scale * (spinModel.matrix.length - 1)
  const py = (1920 - symH * scale * spinModel.matrix[0].length) / 2 + symH * scale * (spinModel.matrix[0].length + 0.5)
  self.addChild(new GraphicsButton(makeGoButtonObj(lx, ly, px, py)))
  //gocheat-button-end

  signal.on('RADIO:ui', function (value) {
    if (value == 'cheat') {
      range.visible = false
      symbolsMatrix = game.models.SpinModel.get().matrix
    }
    fade(value == 'cheat')
  })

  signal.on('BUTTON:cheat', function (value) {
    currentSym = value.split(':')
    range.visible = !range.visible
  })

  signal.on('BUTTON:makecheat', function (value) {
    const [col, row] = currentSym
    symbolsMatrix[col][row] = value
    range.visible = false
  })

  signal.on('BUTTON:GOCHEAT', () => {
    cheat(parseMatrix(symbolsMatrix))
  })

  return self
}

function makeSymbols(value, place, symH, symW) {
  let landX = (1920 - symW * scale * spinModel.matrix.length) / 2
  let portX = (1080 - symW * scale * spinModel.matrix.length) / 2
  value.forEach((item, column) => {
    let landY = (1080 - symH * scale * spinModel.matrix[0].length) / 2
    let portY = (1920 - symH * scale * spinModel.matrix[0].length) / 2
    item.forEach((symbol, row) => {
      const name = `cheat-${column}:${row}`
      const imgMain = new ImageButton(makeMainImageObj(scale, name, landX, landY, portX, portY))
      const images = imgMain.images
      updateSymbol(symbol, images)
      place.addChild(imgMain)

      signal.on('BUTTON:makecheat', (value) => {
        const [c, r] = currentSym
        if ((c == column) && (r == row)) {
          updateSymbol(value, images)
        }
      })
      signal.on('RADIO:ui', function (value) {
        if (value == 'cheat') {
          const currentSymbol = game.models.SpinModel.get().matrix[column][row]
          updateSymbol(currentSymbol, images)
        }
      })
      portY += symH * scale
      landY += symH * scale
    })
    portX += symW * scale
    landX += symW * scale
  })
}

function updateSymbol(symbol, images) {
  const symIndex = spinModel.reelSymbols.indexOf(symbol)
  images.forEach((image, index) => {
    image.visible = index == symIndex
  })
}

function parseMatrix(data) {
  const allLines = []

  for (let reel = 0; reel < data.length; reel++) {
    for (let line = 0; line < data[0].length; line++) {
      reel == 0 && (allLines[line] = '')
      allLines[line] += data[reel][line]
    }
  }

  return allLines.join(',')
}

function makeImageObj(path, scale, name, lx, ly, px, py) {
  return {
    height: 270,
    width: 280,
    images: [`images/items/static/${path}.png`],
    scale: scale,
    name: name,
    orientation: {
      land: {
        x: lx,
        y: ly,
      },
      port: {
        x: px,
        y: py,
      },
    },
  }
}

function makeMainImageObj(scale, name, lx, ly, px, py) {
  return {
    height: 270,
    width: 280,
    images: images,
    scale: scale,
    name: name,
    orientation: {
      land: {
        x: lx,
        y: ly,
      },
      port: {
        x: px,
        y: py,
      },
    },
  }
}

const background = {
  height: 1920,
  width: 1920,
  name: 'background',
  color: '0x000000',
  resize: true,
  orientation: {
    land: {
      x: 0,
      y: -420,
    },
    port: {
      x: -420,
      y: 0,
    },
  },
}

function makeRangeBackground(n, lx, ly, px, py, symH, symW) {
  return {
    height: symH / 2 * n,
    width: symW,
    name: 'background',
    color: '0x0e0455',
    orientation: {
      land: {
        x: lx,
        y: ly,
      },
      port: {
        x: px,
        y: py,
      },
    },
  }
}

function makeGoButtonObj(lx, ly, px, py) {
  return {
    height: 60,
    width: 140,
    name: 'GOCHEAT',
    color: '0x00FF00',
    orientation: {
      land: {
        x: lx,
        y: ly,
      },
      port: {
        x: px,
        y: py,
      },
    },
  }
}
